import { Link } from 'react-router-dom';
import { useI18n } from '@/shared/contexts/I18nProvider';

const footerLinks = [
  { label: 'platform', to: '/', sectionId: 'platform' },
  // { label: 'calculator', to: '/', sectionId: 'calculator' },
  { label: 'insights', to: '/insights' },
  { label: 'cases', to: '/cases' },
  { label: 'contact', to: '/contact' }
] as const;

const Footer = () => {
  const { content, localizedPath } = useI18n();

  return (
    <footer className="border-t border-border-muted bg-background-primary py-8">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 font-mono text-sm text-text-tertiary sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <span>{content.footer.tagline}</span>
        <div className="flex flex-wrap items-center gap-4">
          {footerLinks.map(link => (
            <Link
              key={link.label}
              to={localizedPath(link.to)}
              state={
                'sectionId' in link
                  ? { scrollToSection: link.sectionId }
                  : undefined
              }
              className="hover:text-text-primary"
            >
              {content.nav[link.label]}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
